"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssignmentTableProps = void 0;
const getAssignmentTableProps = (isTest, isSurvey, isHome, isReserve, isTeacher, isBackOffice, isMobile, isTablet) => {
    const isTeacherTestListView = isTeacher && isTest && !isHome && !isReserve && !isBackOffice && !isMobile;
    const headTitleList = isTeacher && isMobile
        ? []
        : isHome
            ? []
            : isReserve
                ? // 예약 페이지
                    [
                        ...(isSurvey ? [] : [{ title: 'type', space: 1, sort: false }]),
                        {
                            title: isSurvey ? 'survey_title' : isTest ? 'test_name' : 'title',
                            space: 2,
                            sort: false,
                        },
                        ...(isTeacher ? [{ title: 'author_name', space: 1, sort: false }] : []),
                    ]
                : isBackOffice
                    ? // 관리자 페이지
                        [
                            { title: 'creation_time', space: 1, sort: false },
                            { title: 'type', space: 1, sort: false },
                            { title: isTest ? 'test_name' : 'title', space: 4, sort: false },
                            { title: 'author_name', space: 1, sort: false },
                            { title: 'disclosure', space: 1, sort: false },
                            { title: 'etc', space: 1, sort: false },
                        ]
                    : isTeacherTestListView
                        ? [
                            { title: 'report_name', space: 1, sort: false },
                            { title: 'test_name', space: 2, sort: false },
                            { title: 'status', space: 1, sort: false },
                            { title: 'progress_period', space: 2, sort: false },
                            // 진행기간(배정) 다음·성적표 앞에 실제 풀이 소요시간 컬럼 추가
                            // (서버 응답에 실제 소요시간 필드가 아직 없어 값은 AssignmentItem에서 '-' placeholder)
                            { title: 'solve_time', space: 1, sort: false },
                            { title: 'grade_report', space: 1, sort: false },
                            { title: 'manage', space: 1, sort: false },
                        ]
                        : isSurvey && isTablet
                            ? [
                                { title: 'survey_title', space: 3, sort: false },
                                { title: 'status', space: 1, sort: false },
                                { title: 'startline', space: 2, sort: false },
                                { title: 'deadline', space: 2, sort: false },
                                ...(isTeacher
                                    ? [
                                        { title: 'author_name', space: 1, sort: false },
                                        { title: 'etc', space: 1, sort: false },
                                    ]
                                    : []),
                            ]
                            : isSurvey
                                ? [
                                    { title: 'survey_title', space: 3, sort: false },
                                    { title: 'status', space: 1, sort: false },
                                    { title: 'startline', space: 1, sort: false },
                                    { title: 'deadline', space: 1, sort: false },
                                    ...(isTeacher
                                        ? [
                                            { title: 'author_name', space: 1, sort: false },
                                            { title: 'etc', space: 1, sort: false },
                                        ]
                                        : []),
                                ]
                                : isTablet
                                    ? // 태블릿 페이지
                                        [
                                            // { title: 'creation_time', space: 1, sort: false },
                                            {
                                                title: `type_and_${isTest ? 'test' : 'subject'}_name`,
                                                space: 3,
                                                sort: false,
                                            },
                                            { title: 'status', space: 1, sort: false },
                                            ...(isTest
                                                ? [
                                                    {
                                                        title: 'class_name',
                                                        space: 2,
                                                        sort: false,
                                                    },
                                                ]
                                                : []),
                                            ...(!isTest
                                                ? [
                                                    { title: 'startline', space: 2, sort: false },
                                                    { title: 'deadline', space: 2, sort: false },
                                                ]
                                                : [
                                                    { title: 'progressdate', space: 1, sort: false },
                                                    { title: 'duration', space: 1, sort: false },
                                                ]),
                                            ...(isTeacher
                                                ? [
                                                    { title: 'author_name', space: 1, sort: false },
                                                    { title: 'etc', space: 1, sort: false },
                                                ]
                                                : []),
                                        ]
                                    : // 그 외
                                        [
                                            // { title: 'creation_time', space: 1, sort: false },
                                            { title: 'type', space: 1, sort: false },
                                            {
                                                title: isTest ? 'test_name' : 'title',
                                                space: 3,
                                                sort: false,
                                            },
                                            { title: 'status', space: 1, sort: false },
                                            ...(!isTest
                                                ? [
                                                    { title: 'startline', space: 1, sort: false },
                                                    { title: 'deadline', space: 1, sort: false },
                                                ]
                                                : [
                                                    { title: 'class_name', space: 2, sort: false },
                                                    { title: 'progressdate', space: 1, sort: false },
                                                    { title: 'duration', space: 1, sort: false },
                                                ]),
                                            ...(isTeacher
                                                ? [
                                                    { title: 'author_name', space: 1, sort: false },
                                                    { title: 'etc', space: 1, sort: false },
                                                ]
                                                : []),
                                        ];
    const tableReadDataKeys = isHome
        ? isTest
            ? [
                { title: 'statusAndTitle', space: 4, sort: false },
                // { title: 'creation_time', space: 1, sort: false },
            ]
            : [
                { title: 'statusAndTitle', space: 4, sort: false },
                { title: 'submitDate', space: 1, sort: false },
            ]
        : isReserve
            ? // 예약 페이지
                [
                    ...(isSurvey
                        ? [{ title: 'survey_title', space: 2, sort: false }]
                        : isMobile
                            ? [
                                {
                                    title: `type_and_${isTest ? 'test' : 'subject'}_name`,
                                    space: 2,
                                    sort: false,
                                },
                            ]
                            : [
                                { title: 'type', space: 1, sort: false },
                                { title: 'title', space: 2, sort: false },
                            ]),
                    ...(isTeacher ? [{ title: 'author_name', space: 1, sort: false }] : []),
                ]
            : isBackOffice
                ? // 관리자 페이지
                    [
                        { title: 'creation_time', space: 1, sort: false },
                        { title: 'type', space: 1, sort: false },
                        { title: 'title', space: 4, sort: false },
                        { title: 'author_name', space: 1, sort: false },
                        { title: 'status', space: 1, sort: false },
                        { title: 'etc', space: 1, sort: false },
                    ]
                : isTeacherTestListView
                    ? [
                        { title: 'report_name', space: 1, sort: false },
                        { title: 'test_name', space: 2, sort: false },
                        { title: 'status', space: 1, sort: false },
                        { title: 'progress_period', space: 2, sort: false },
                        // 진행기간(배정) 다음·성적표 앞에 실제 풀이 소요시간 컬럼 추가
                        // (서버 응답에 실제 소요시간 필드가 아직 없어 값은 AssignmentItem에서 '-' placeholder)
                        { title: 'solve_time', space: 1, sort: false },
                        { title: 'grade_report', space: 1, sort: false },
                        { title: 'manage', space: 1, sort: false },
                    ]
                    : isMobile
                        ? [
                            { title: 'etc', space: 1, sort: false },
                            // { title: 'title', space: 1, sort: false },
                            // { title: 'type', space: 1, sort: false },
                            // // { title: 'startline', space: 1, sort: false },
                            // { title: 'deadline', space: 1, sort: false },
                            // // { title: 'duration', space: 1, sort: false },
                            { title: 'mobile', space: 1, sort: false },
                        ]
                        : isSurvey && isTablet
                            ? [
                                { title: 'survey_title', space: 3, sort: false },
                                { title: 'status', space: 1, sort: false },
                                { title: 'startline', space: 2, sort: false },
                                { title: 'deadline', space: 2, sort: false },
                                ...(isTeacher
                                    ? [
                                        { title: 'author_name', space: 1, sort: false },
                                        { title: 'etc', space: 1, sort: false },
                                    ]
                                    : []),
                            ]
                            : isSurvey
                                ? [
                                    { title: 'survey_title', space: 3, sort: false },
                                    { title: 'status', space: 1, sort: false },
                                    { title: 'startline', space: 1, sort: false },
                                    { title: 'deadline', space: 1, sort: false },
                                    ...(isTeacher
                                        ? [
                                            { title: 'author_name', space: 1, sort: false },
                                            { title: 'etc', space: 1, sort: false },
                                        ]
                                        : []),
                                ]
                                : isTablet
                                    ? // 태블릿 페이지
                                        [
                                            // { title: 'creation_time', space: 1, sort: false },
                                            {
                                                title: `type_and_${isTest ? 'test' : 'subject'}_name`,
                                                space: 3,
                                                sort: false,
                                            },
                                            { title: 'status', space: 1, sort: false },
                                            ...(isTest
                                                ? [
                                                    {
                                                        title: 'conference_name',
                                                        space: 2,
                                                        sort: false,
                                                    },
                                                ]
                                                : []),
                                            ...(!isTest
                                                ? [
                                                    { title: 'startline', space: 2, sort: false },
                                                    { title: 'deadline', space: 2, sort: false },
                                                ]
                                                : [
                                                    { title: 'progressdate', space: 1, sort: false },
                                                    { title: 'duration', space: 1, sort: false },
                                                ]),
                                            ...(isTeacher
                                                ? [
                                                    { title: 'author_name', space: 1, sort: false },
                                                    { title: 'etc', space: 1, sort: false },
                                                ]
                                                : []),
                                        ]
                                    : // 그 외
                                        [
                                            // { title: 'creation_time', space: 1, sort: false },
                                            { title: 'type', space: 1, sort: false },
                                            {
                                                title: 'title',
                                                space: 3,
                                                sort: false,
                                            },
                                            { title: 'status', space: 1, sort: false },
                                            ...(!isTest
                                                ? [
                                                    { title: 'startline', space: 1, sort: false },
                                                    { title: 'deadline', space: 1, sort: false },
                                                ]
                                                : [
                                                    { title: 'conference_name', space: 2, sort: false },
                                                    { title: 'progressdate', space: 1, sort: false },
                                                    { title: 'duration', space: 1, sort: false },
                                                ]),
                                            ...(isTeacher
                                                ? [
                                                    { title: 'author_name', space: 1, sort: false },
                                                    { title: 'etc', space: 1, sort: false },
                                                ]
                                                : []),
                                        ];
    return {
        headTitleList,
        tableReadDataKeys,
    };
};
exports.getAssignmentTableProps = getAssignmentTableProps;
